import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Login from './Login';
import SystemChoice from './SystemChoice';
import ModernChatInterface from './ModernChatInterface';
import BingoInterface from './BingoInterface';
import WeddingPlanner from './WeddingPlanner';
import ExpensesDashboard from './ExpensesDashboard';
import NotesInterface from './NotesInterface';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <Router>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <SystemChoice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ModernChatInterface />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bingo"
          element={
            <ProtectedRoute>
              <BingoInterface />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wedding"
          element={
            <ProtectedRoute>
              <WeddingPlanner />
            </ProtectedRoute>
          }
        />

        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <ExpensesDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/notes"
          element={
            <ProtectedRoute>
              <NotesInterface />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
